import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User applied a filter on the creative performance page',
  name: 'creative_performance_filter_applied',
  params: [
    {
      description: 'The type of filter applied',
      name: 'type',
      required: true,
      type: 'enum',
      values: ['status', 'campaign', 'ad_set'],
    },
  ],
};

export default META;
